


export const hasOwnPropertyTS = <X extends object, Y extends PropertyKey>(obj: X, prop: Y): obj is X & Record<Y, unknown> => {
	return obj.hasOwnProperty(prop)
}


export const invalidFormValue = (value: unknown | null | undefined) => {
	if (value === null || value === undefined) return true;
	if (typeof value === 'string' && value === '') return true;
	if (typeof value === 'number' && value === 0) return true;
	if (Number.isNaN(value)) return true;
	return false;
}



export const isValidEmail = (email: string | null | undefined) =>
	email ? /^\S+@\S+\.\w+$/.test(email) : false;



export const isValidPhoneNumber = (numberString: string | null | undefined) =>
	numberString ? /\+?[\d\s]+\d$/.test(numberString) : false;



export const getEuroPrice = (value: number) => {
	let eurPrice = value / 24;
	let roundedPrice = Math.round((eurPrice + Number.EPSILON) * 100) / 100;
	return String(roundedPrice).replace('.', ',');
};

export const renderPrice = (value: number) => {
	return String(value).replace('.', ',');
};


export const isZasilkovnaId = (deliveryId: number) => {
	if (!deliveryId || !process.env.ZASILKOVNA_ID) return false;

	const allIds = process.env.ZASILKOVNA_ID.split(',');
	if (!allIds || allIds.length === 0) return false;

	return allIds.map(x => parseInt(x)).includes(deliveryId);
};


export const isDpdId = (deliveryId: number) => {
	if (!deliveryId || !process.env.DPD_ID) return false;

	const allIds = process.env.DPD_ID.split(',');
	if (!allIds || allIds.length === 0) return false;

	return allIds.map(x => parseInt(x)).includes(deliveryId);
};